import './Space.less'
import Space from './Space'

export default Space
